export default [
  {
    title: 'Create new widget',
    icon: 'plus',
    clickHandler: 'addWidget',
    isModerator: true
  },
  {
    title: 'Computed properties',
    icon: 'code',
    clickHandler: 'showComputed',
    isModerator: true
  },
  {
    title: 'Add spreadsheet',
    icon: 'table',
    clickHandler: 'addSpreadsheet',
    isModerator: true
  },
  {
    title: 'Add Pivot Table',
    icon: 'columns',
    clickHandler: 'addPivotTable',
    isModerator: true
  },
  {
    title: 'Add Chart',
    icon: 'area-chart',
    clickHandler: 'addChart',
    isModerator: true
  },
  {
    title: 'Widgets data',
    icon: 'cubes',
    clickHandler: 'showDataTree',
    isAdmin: true
  },
  {
    title: 'Create data widget',
    icon: 'cube',
    clickHandler: 'addDataWidget',
    isAdmin: true
  },
  {
    title: 'Share dashboard',
    icon: 'share-alt',
    clickHandler: 'shareDashboard',
    isDashOwner: true
  },
  {
    title: 'Invite new user',
    icon: 'user-circle',
    clickHandler: 'inviteNewUser',
    isUserManager: true
  },
  {
    title: 'Dashboard Access',
    icon: 'lock',
    clickHandler: 'editDashboardAccess',
    isUserManager: true
  },
  {
    title: 'Custom code',
    icon: 'jsfiddle',
    clickHandler: 'showCustomCode',
    isModerator: true
  }
]



// WEBPACK FOOTER //
// ./src/components/Toolbar/menuTree.js